import React, { Component } from 'react';
import Home from './pages/home/Home';
import SystemHome from './pages/SystemHome';
import 'typeface-roboto';
import LoadingScreen from 'react-loading-screen'
import Alert from './global/Alert';
import server from './server';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";

function LoggedRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        server.user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

class App extends Component {
  state = {
    page: 2,
    logged: false,
    loading:true
  }

  alert = (title,message,mode) =>{
    clearTimeout(this.state.timeout);
    let timeout = setTimeout(() => this.setState({modal:false}), 3000);
    this.setState({timeout:timeout, title:title.toString(),mode: mode, message:message.toString(),modal:true});
  }

  componentWillMount(){
    var sheet = document.createElement('style')
    sheet.innerHTML = "";
    document.body.appendChild(sheet);
    this.setState({sheet:sheet},() => this.loadStyle(""))
  }

  changeStyle = () =>{
    this.state.sheet.innerHTML = this.state.globals + "\n" + this.state.style;
    this.setState({loading:false})
  }

  loadGlobals = (i) =>{
    fetch(server.address + "/static/globals" + i + ".css",{
      method:"GET"
    }).then(response => response.text().then(data => this.setState({globals:data}, this.changeStyle)));
  }

  loadStyle = (i) =>{
    fetch(server.address + "/static/style" + i + ".css",{
      method:"GET"
    }).then(response => response.text().then(data => this.setState({style:data}, () => this.loadGlobals(i))));
  }

  logout = () =>{
    localStorage.setItem("autoLogin",false);
    this.loadStyle("");
    this.setState({logged:false, loading:true});
  }

  render() {

    return(
        <div style={{height:"100%"}}>
          {this.state.loading?
            <LoadingScreen
            loading={true}
            bgColor='#f1f1f1'
            spinnerColor='#9ee5f8'
            textColor='#676767'
            logoSrc='/assets/images/logo-blue.svg'/> 
          :
          <div style={{height:"100%"}}>
              <Alert open={this.state.modal} close={()=>{this.setState({modal:false})}} mode={this.state.mode} title={this.state.title}  message={this.state.message}/>
              <Router>
                <div style={{height:"100%"}}>
                  <Route path="/" exact component={() => <Redirect to="/home"/>}/>
                  <LoggedRoute path="/sistema" component={() => <SystemHome alert={this.alert} logout={this.logout}/>} />
                  <Route path="/home" component={() => <Home alert={this.alert} id={0} logged={() => {this.setState({loading:true}, () => this.loadStyle("2"))}}/>}/>
                </div>
              </Router>
          </div>
            }
        </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js